import type { CityConfig } from "../city-template/types";

export const westFargoConfig: CityConfig = {
  city: "West Fargo",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "west-fargo",
  route: "/cities/west-fargo",
  title: "Emergency Passport West Fargo, ND — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in West Fargo, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving West Fargo, Cass County, and Fargo-Moorhead metro travelers. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in West Fargo, ND",
  heroSubtitle: "Live in West Fargo and need a passport fast? Whether you're a NDSU student studying abroad, a Sanford Health professional attending an international conference, or a Fargo-Moorhead family planning a trip — we've got you covered. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20West%20Fargo%20North%20Dakota%20suburban%20skyline%20with%20modern%20residential%20neighborhoods%20and%20Sheyenne%20River%20greenway%20in%20the%20foreground%2C%20the%20growing%20Sheyenne%20Street%20corridor%20with%20shops%20and%20restaurants%2C%20prairie%20horizon%20with%20dramatic%20North%20Dakota%20big%20sky%20at%20golden%20sunset%20hour%20with%20warm%20amber%20light%20over%20the%20Red%20River%20Valley%20landscape%2C%20editorial%20travel%20photography%20with%20crisp%20detail&width=1800&height=700&seq=west-fargo-hero-2026&orientation=landscape",
  heroImageAlt: "West Fargo North Dakota suburban skyline with Sheyenne River at golden hour",
  geoPosition: "46.8769;-96.9003",
  geoPlacename: "West Fargo, North Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Nearest regional passport agency — located approximately 245 miles from West Fargo; about a 4-hour drive",
  },
  nearbyCitiesZips: [
    { name: "West Fargo", zips: "58078" },
    { name: "Fargo", zips: "58102, 58103, 58104" },
    { name: "Horace", zips: "58047" },
    { name: "Harwood", zips: "58042" },
    { name: "Mapleton", zips: "58059" },
    { name: "Casselton", zips: "58012" },
    { name: "Kindred", zips: "58051" },
  ],
  benefits: [
    { icon: "ri-building-2-line", title: "Fargo-Moorhead Metro Access", desc: "West Fargo residents benefit from being part of the largest metro area in North Dakota. With Hector International Airport (FAR) just minutes away, you can connect through Minneapolis or Denver for international flights — and we make sure your passport is ready before you board." },
    { icon: "ri-flight-takeoff-line", title: "FAR — Hector International Airport", desc: "Daily flights to Minneapolis, Denver, Chicago, and Dallas. West Fargo is just 10 minutes from the terminal. We coordinate processing timelines around your FAR departure — your passport should be valid at check-in." },
    { icon: "ri-graduation-cap-line", title: "NDSU Study Abroad & Research", desc: "North Dakota State University students and faculty travel internationally for research collaborations, study abroad programs, and academic conferences. We process expedited passports for the university community on tight academic timelines." },
    { icon: "ri-home-2-line", title: "Fastest-Growing ND City", desc: "West Fargo is North Dakota's fastest-growing city, with new residents arriving from across the country. Many need first-time passports or need to update documents after relocating — we help new West Fargo residents get travel-ready fast." },
  ],
  internalLinks: [
    { name: "Expedited passport in Fargo, ND", route: "/cities/fargo" },
    { name: "Fast passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "Quick passport services in Grand Forks, ND", route: "/cities/grand-forks" },
    { name: "Urgent passport services in Minot, ND", route: "/cities/minot" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves West Fargo via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 4+ hours to Minnesota. West Fargo residents can ship from any UPS Store, FedEx Office, or post office location across the Fargo-Moorhead metro.",
  fpcOfficeDistance: "Serving West Fargo, Horace, Harwood, Mapleton, Casselton, Kindred, and all Cass County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout West Fargo and the Sheyenne River corridor. From the growing Sheyenne Street business district to the new residential developments south of I-94, from NDSU students to Sanford health professionals — we serve all of West Fargo and Cass County. Our courier service eliminates the need to drive to Minneapolis for a passport agency appointment.",
  nearbyCitiesIntro: "We serve West Fargo and all Cass County communities including Horace, Harwood, Mapleton, and Casselton. As part of the Fargo-Moorhead metropolitan area, we also coordinate closely with Fargo, Moorhead, and Dilworth travelers who need expedited passport processing.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in West Fargo as simple as possible — with the efficiency growing families, NDSU students, and Red River Valley professionals need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most West Fargo travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "West Fargo's rapid growth creates unique passport situations — new residents with out-of-state documents, NDSU academic travel timelines, and winter weather affecting mail delivery. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "West Fargo travelers — from growing families in the Eagle Run and The Wilds developments to NDSU faculty and Sanford Health professionals — trust us when their international departure is days away and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in West Fargo, ND? Here are the most common ones we hear from our neighbors in the fastest-growing city in North Dakota.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you're a new West Fargo resident needing a first passport, an NDSU student preparing for study abroad, or a family planning a vacation from FAR — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30-100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 245 miles from West Fargo", "Still a 4+ hour drive one way"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in West Fargo", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "FAR flight to Minneapolis connecting to an international departure in 2 days? Urgent family emergency overseas? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for West Fargo travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help West Fargo residents renew fast — no agency visit required for most renewals. Perfect for families planning summer vacations, business travelers, and new residents updating documents.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide West Fargo residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your FAR departure or NDSU study abroad semester isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your West Fargo family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for new West Fargo residents updating documents after relocation.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for NDSU researchers with overlapping international conferences and Sanford Health professionals attending global medical summits.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide West Fargo travelers through the process so your international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for West Fargo residents crossing into Manitoba for shopping and recreation.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport West Fargo ND", description: "Urgent passport processing for West Fargo North Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal West Fargo ND", description: "Fast passport renewal for West Fargo North Dakota residents." },
    { name: "First-Time Passport West Fargo ND", description: "New passport application services for West Fargo North Dakota first-time applicants." },
    { name: "Child Passport West Fargo ND", description: "Minor passport services for West Fargo North Dakota families with children under 16." },
    { name: "Name Change Passport West Fargo ND", description: "Passport name correction for West Fargo residents after marriage or legal name changes." },
    { name: "Second Passport West Fargo ND", description: "Second passport services for West Fargo frequent travelers and professionals." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "West Fargo",
      rating: 5,
      text: "We just moved to The Wilds development from Arizona and discovered our passports had expired right before a family wedding in Cabo. Fast Passport Center got all four of us renewed in under a week. Being new to North Dakota, I had no idea where to go — their remote service was a lifesaver.",
      service: "Family Passport Renewal — 4 passports",
    },
    {
      name: "Dr. Marcus T.",
      location: "West Fargo",
      rating: 5,
      text: "I'm an NDSU researcher presenting at a conference in Berlin and realized my passport was expiring three weeks before departure. Fast Passport Center processed my renewal in 4 days. I didn't have to miss a single day of lab work to drive to Minneapolis.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "The Nguyen Family",
      location: "West Fargo",
      rating: 5,
      text: "We planned a trip to Vietnam to visit family — our kids needed first passports and our renewals were overdue. The team walked us through every step, from the acceptance facility visit to final delivery. All five passports arrived with time to spare before our FAR departure.",
      service: "Family Passports — New + Renewals",
    },
    {
      name: "Jennifer L.",
      location: "Horace",
      rating: 5,
      text: "Sanford Health sent me to a medical conference in London on 10 days' notice. My passport had expired and I panicked. Fast Passport Center had it back to me in 3 days. As a healthcare professional, I don't have time for bureaucracy — they made it effortless.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "west-fargo-1",
      name: "West Fargo Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 Main Ave W",
      city: "West Fargo",
      state: "ND",
      zip: "58078",
      phone: "(701) 282-3358",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Downtown West Fargo",
      website: "https://tools.usps.com/find-location.htm?location=1388375",
      websiteLabel: "USPS Location",
      notes: "Convenient acceptance facility for West Fargo residents. Passport photos available on-site. Appointment recommended — schedule at least a week in advance during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "west-fargo-2",
      name: "Fargo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "657 2nd Ave N",
      city: "Fargo",
      state: "ND",
      zip: "58102",
      phone: "(701) 241-6110",
      hours: "Mon-Fri 8:30 AM - 5:00 PM (appointment required)",
      distance: "Downtown Fargo — about 8 miles from West Fargo",
      website: "https://tools.usps.com/find-location.htm?location=1378259",
      websiteLabel: "USPS Location",
      notes: "Larger facility with daily passport acceptance. More appointment slots available than West Fargo office. Passport photos on-site. About 15-minute drive from West Fargo.",
      icon: "ri-mail-line",
    },
    {
      id: "west-fargo-3",
      name: "Cass County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "211 9th St S",
      city: "Fargo",
      state: "ND",
      zip: "58103",
      phone: "(701) 451-6900",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      distance: "Downtown Fargo — about 10 miles from West Fargo",
      website: "https://www.casscountynd.gov/",
      websiteLabel: "Cass County Website",
      notes: "Alternative acceptance option for Cass County residents. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "west-fargo-4",
      name: "NDSU Post Office",
      type: "USPS Contract Station",
      address: "Memorial Union, NDSU Campus",
      city: "Fargo",
      state: "ND",
      zip: "58102",
      phone: "(701) 231-7222",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (academic year hours)",
      distance: "NDSU Campus — about 7 miles from West Fargo",
      website: "https://www.ndsu.edu/mu/services/post_office/",
      websiteLabel: "NDSU Post Office",
      notes: "Convenient for NDSU students and faculty on campus. Limited passport acceptance hours — call ahead. Check for reduced hours during summer and university breaks.",
      icon: "ri-government-line",
    },
    {
      id: "west-fargo-5",
      name: "Moorhead Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "119 5th St S",
      city: "Moorhead",
      state: "MN",
      zip: "56560",
      phone: "(218) 233-3165",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Moorhead, MN — about 10 miles from West Fargo (across the Red River)",
      website: "https://tools.usps.com/find-location.htm?location=1374894",
      websiteLabel: "USPS Location",
      notes: "Minnesota-side option for West Fargo residents near the Red River. Another acceptance facility in the metro area. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 245 miles and 4+ hour drive from West Fargo", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Minneapolis; takes a full day from West Fargo", fpc: "Most West Fargo travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for West Fargo", agency: "245-mile drive to Minneapolis one way — 8+ hours round trip driving", fpc: "Entirely remote — forms online, ship from West Fargo, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in time off work and Minneapolis travel", fpc: "Best price guarantee — 30-100% less than FedEx, Staples and resellers" },
    { feature: "West Fargo Context", agency: "No local guidance — no NDSU, Sanford, or West Fargo growth expertise", fpc: "Full West Fargo knowledge — NDSU, Sanford, growing families, new residents" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "New Resident Document Confusion",
      description: "West Fargo is North Dakota's fastest-growing city, with new residents arriving from across the country. Many bring out-of-state birth certificates and IDs that need extra validation for passport applications. We help new West Fargo residents sort through document requirements specific to their previous state.",
    },
    {
      icon: "ri-error-warning-line",
      title: "NDSU Study Abroad Passport Timing",
      description: "NDSU students planning study abroad semesters often wait until the last few weeks before departure to check their passports. International student visas, host country requirements, and academic calendar deadlines all overlap — creating a passport crunch that's entirely avoidable with earlier planning.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Winter Weather Mail Delays",
      description: "Red River Valley winters bring blizzards that can delay mail by several days. When your international departure is from FAR connecting through Minneapolis, a 2-day winter storm can wreck your passport timeline. We use overnight courier channels that aren't affected by local weather delays.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Canadian Border Travel Assumptions",
      description: "West Fargo residents are just 2.5 hours from the Manitoba border and often cross into Canada for shopping, fishing trips, and Winnipeg getaways. Many assume a REAL ID or enhanced driver's license is sufficient — but a passport or passport card is still required for Canadian border crossings.",
    },
    {
      icon: "ri-error-warning-line",
      title: "FAR Connection Passport Validity Gaps",
      description: "Hector International Airport connects through Minneapolis, Denver, and Chicago. Many West Fargo travelers assume their passport only needs to be valid at the international gateway, not at FAR check-in. Airlines can deny boarding at Hector if your passport doesn't meet destination requirements.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a family vacation, NDSU study abroad, or business trip from FAR." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're a new West Fargo resident or a longtime Cass County local." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most West Fargo clients ship from the UPS Store on 13th Ave or the West Fargo Post Office — no Minneapolis trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so West Fargo travelers never need to drive to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your West Fargo address — whether that's in Eagle Run, The Wilds, or downtown. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in West Fargo, North Dakota?", a: "We offer West Fargo area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is in Minneapolis (245 miles away), our remote courier service is the most practical fast option in the Red River Valley." },
    { q: "Do I need to visit a West Fargo office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (West Fargo Post Office, Fargo Main Post Office, or Cass County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your West Fargo address." },
    { q: "Can NDSU students get expedited passports for study abroad?", a: "Yes. NDSU students studying abroad are frequent clients. We understand academic timelines and can process passports in time for semester departures. We recommend NDSU students start the process as soon as they're accepted to their study abroad program — ideally 8+ weeks before departure for standard processing, or use our expedited service for tighter timelines." },
    { q: "What if I need a passport and Minneapolis is too far?", a: "Minneapolis Passport Agency is 245 miles from West Fargo — about a 4-hour drive. That's a full day of travel and potentially an overnight stay. Our registered courier service handles the agency submission remotely, so you never leave the Fargo-Moorhead metro." },
    { q: "What is the best price for expedited passport service in West Fargo?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "Can new West Fargo residents get passports with out-of-state documents?", a: "Yes. Many West Fargo residents recently relocated from other states. We help you navigate passport applications using out-of-state birth certificates, previous state IDs, and other documentation. The requirements are the same — we just make sure everything is correctly prepared to avoid rejections." },
    { q: "What documents do West Fargo applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos." },
    { q: "Can I get a passport photo in West Fargo?", a: "Yes. The West Fargo Post Office offers passport photos, as does the Fargo Main Post Office. Walgreens on 13th Ave, CVS, and Walmart in Fargo also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does winter weather affect passport processing from West Fargo?", a: "Red River Valley winter storms can delay standard mail by 2-4 days. We use overnight courier shipping to eliminate weather-related delays — your documents arrive the next business day regardless of North Dakota winter conditions. This is especially important for West Fargo residents with tight travel deadlines." },
    { q: "Can I use a passport card for Canada trips from West Fargo?", a: "Yes. West Fargo is about 2.5 hours from the Manitoba border, and many residents cross into Canada regularly. A passport card works for land and sea crossings to Canada, Mexico, and the Caribbean. It's wallet-sized and processes faster than a full passport book — a great option for frequent Canada visitors." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for West Fargo Residents",
    intro: "West Fargo's position in the Red River Valley — part of the Fargo-Moorhead metro, home to NDSU, and North Dakota's fastest-growing city — creates distinct passport timing needs. Here's what West Fargo travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "FAR — Hector International Airport",
        subtitle: "The metro's air gateway, minutes from West Fargo",
        description: "FAR serves the entire Fargo-Moorhead region with daily flights to Minneapolis, Denver, Chicago, and Dallas. Most West Fargo international travelers connect through MSP for overseas flights. The airport is just 10 minutes from West Fargo — meaning passport check-in happens right here in the Red River Valley, not at your connection point.",
        tip: "Airlines can deny boarding at FAR if your passport doesn't meet destination validity requirements. Don't assume your passport only needs to be valid at Minneapolis or Denver — the check happens at Hector.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "NDSU — International Research & Study Abroad",
        subtitle: "University travelers with academic timelines",
        description: "North Dakota State University drives significant international travel from West Fargo — students heading abroad for semesters in Europe and Asia, faculty presenting research at global conferences, and international collaborations spanning agriculture, engineering, and health sciences. Academic travel often has inflexible dates tied to semester schedules and conference programs.",
        tip: "NDSU travelers should check passport validity at least 90 days before any international academic commitment. Many countries require 6 months of passport validity beyond your planned return date — a common issue for students returning after semester's end.",
      },
      {
        icon: "ri-heart-pulse-line",
        title: "Sanford Health International Travel",
        subtitle: "Healthcare professionals attending global conferences",
        description: "Sanford Health's presence in Fargo creates demand for international medical conference travel, humanitarian medical missions, and research collaborations. Healthcare professionals often get short-notice conference invitations and need fast passport processing without disrupting patient care schedules.",
        tip: "Sanford professionals should maintain valid passports proactively. Conference invitations often come with 2-4 weeks' notice — our expedited service can handle those timelines, but starting with a valid passport is always better.",
      },
      {
        icon: "ri-home-smile-line",
        title: "Growing Families & New Residents",
        subtitle: "North Dakota's fastest-growing city means lots of new passport needs",
        description: "West Fargo's rapid growth brings new residents who need first passports, families with children who've never had passports, and relocating professionals updating documents. The city's young demographic means lots of family travel — school break vacations, destination weddings, and visits to relatives abroad.",
        tip: "New West Fargo residents should check all family members' passport status when relocating. Moving is chaotic enough — discovering expired passports 2 weeks before a planned trip adds unnecessary stress. We can process multiple family applications simultaneously.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "West Fargo & the Canadian Border",
      description: "West Fargo sits just 2.5 hours south of the Manitoba border on I-29. Winnipeg is a popular weekend destination for shopping, Jets games, and cultural events. The Pembina/Emerson border crossing on I-29 is the primary route into Canada, making passport cards particularly practical for West Fargo residents who cross regularly.",
    },
  },
  destinations: {
    title: "Where West Fargo Travelers Go — And Why Passports Get Urgent",
    intro: "West Fargo's university town energy, growing professional class, and family-friendly culture shape its international travel patterns.",
    stats: [
      { stat: "40%", label: "of West Fargo expedited requests involve family vacations and destination events" },
      { stat: "3-4 Weeks", label: "average lead time from trip booking to departure for Red River Valley travelers" },
      { stat: "May-Aug", label: "peak season for family summer travel and NDSU study abroad departures" },
      { stat: "245 Miles", label: "distance to nearest passport agency in Minneapolis — our courier bridges this" },
    ],
    destinations: [
      { name: "Canada", context: "Winnipeg weekend trips, Manitoba fishing and outdoor recreation, business connections between Fargo-Moorhead metro and Canadian Prairie provinces", urgency: "Year-round steady demand — passport cards especially popular for frequent cross-border travelers", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from North Dakota's brutal cold, destination weddings, all-inclusive resort vacations through FAR connections", urgency: "Peak bookings November through February as residents plan warm escapes", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "NDSU study abroad semesters, faculty research collaborations, Sanford medical conferences in London, Berlin, and Vienna, family heritage trips", urgency: "Academic calendar-driven — August and January peak for semester departures", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "NDSU research partnerships with Chinese and Japanese universities, family visits to Vietnam, Philippines, and India, business connections through Minneapolis and Chicago hubs", urgency: "Academic and family-driven — 4-8 week planning window typical", icon: "ri-map-pin-2-line" },
      { name: "Central & South America", context: "NDSU agricultural research in Brazil and Argentina, medical missions through Sanford, eco-tourism and adventure travel", urgency: "Research calendar and mission trip schedules — typically 6-12 week lead time", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "NDSU exchange programs, gap year travel for West Fargo students, once-in-a-lifetime family trips", urgency: "Long-haul trips with extensive planning — passport issues often discovered late in the planning process", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Peace Garden State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Fargo", route: "/cities/fargo" },
      { name: "Bismarck", route: "/cities/bismarck" },
      { name: "Grand Forks", route: "/cities/grand-forks" },
    ],
  },
  photoLocations: [
    { name: "West Fargo Post Office", address: "315 Main Ave W, West Fargo, ND 58078", hours: "Mon-Fri 9 AM - 4 PM (photo service available)" },
    { name: "Walgreens — West Fargo", address: "1200 13th Ave E, West Fargo, ND 58078", hours: "Daily 8 AM - 10 PM" },
    { name: "Walmart Supercenter — Fargo", address: "3757 55th Ave S, Fargo, ND 58104", hours: "Daily 6 AM - 11 PM" },
    { name: "CVS Pharmacy — Fargo", address: "2301 University Dr S, Fargo, ND 58103", hours: "Daily 8 AM - 9 PM" },
    { name: "The UPS Store — West Fargo", address: "745 31st Ave E, West Fargo, ND 58078", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "North Dakota DOT — Fargo Driver License Office",
      address: "855 45th St S, Fargo, ND 58103",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Primary office serving West Fargo and Cass County. About 15 minutes from West Fargo.",
      featured: true,
    },
    {
      name: "Cass County Treasurer — Motor Vehicle",
      address: "211 9th St S, Fargo, ND 58103",
      hours: "Mon-Fri, 8:00 AM - 5:00 PM",
      note: "Vehicle registration and title services. For driver licenses, visit the ND DOT office on 45th St.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FAR",
      name: "Hector International Airport",
      distance: "About 10 minutes east of West Fargo",
      address: "2801 32nd Ave N, Fargo, ND 58102",
      note: "Serves the entire Fargo-Moorhead metro with daily flights to Minneapolis, Denver, Chicago, and Dallas. Primary air gateway for West Fargo residents connecting to international flights. Just 10-15 minutes from any West Fargo neighborhood.",
      flightUrl: "https://www.fargoairport.com/",
      flightLabel: "Hector Airport Website",
      featured: true,
    },
    {
      code: "GFK",
      name: "Grand Forks International Airport",
      distance: "About 80 miles north of West Fargo (1 hour 15 minutes via I-29)",
      address: "2301 Airport Dr, Grand Forks, ND 58203",
      note: "Alternative regional airport with flights to Minneapolis and seasonal routes. Useful if FAR flights are fully booked or for travelers in northern Cass County.",
      flightUrl: "https://www.gfkairport.com/",
      flightLabel: "Grand Forks Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through ND Department of Health Vital Records. Required for estate and legal matters in Cass County.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Cass County Clerk of Court. Certified copies available for name changes and passport applications.",
      url: "https://www.casscountynd.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Cass County District Court. Required for name change passport corrections.",
      url: "https://www.casscountynd.gov/",
    },
  ],
};